module.exports = __webpack_public_path__ + "d664201f/img/settings-ico.a214628d.svg";